var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16537 5.11677V5.50011C9.16485 6.39862 8.87391 7.27289 8.33592 7.99253C7.79793 8.71218 7.04173 9.23864 6.1801 9.4934C5.31846 9.74816 4.39756 9.71757 3.55473 9.40618C2.7119 9.0948 1.9923 8.51931 1.50326 7.76555C1.01423 7.01179 0.781944 6.12013 0.841063 5.22357C0.900182 4.32701 1.24753 3.47358 1.83131 2.79055C2.4151 2.10753 3.20403 1.63152 4.08044 1.4335C4.95686 1.23549 5.87381 1.32608 6.69453 1.69177",
    stroke: "#006465",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 2.16699L5 6.33783L3.75 5.08783",
    stroke: "#006465",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle1);
export default __webpack_public_path__ + "static/media/check-circle-1.a7ab4506c539005bcffa622be7b2fe39.svg";
export { ForwardRef as ReactComponent };